import React, { Component } from 'react';
import { Link } from 'react-router';

export default class ChangeTempPasswordSuccess extends Component {

  render () {
    return (
      <div>
        <h1>Password Changed!</h1>
        <Link to="/" className="btn btn-lg btn-primary">
          Return to Dashboard
        </Link>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/auth/changeTempPasswordSuccess.jsx